module.exports = __webpack_public_path__ + "static/img/04.11a6278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/04.jpg
// module id = +Bfq
// module chunks = 0